import { render } from "./MW2023Form.vue?vue&type=template&id=3e2f0ff9&scoped=true"
import script from "./MW2023Form.vue?vue&type=script&lang=js"
export * from "./MW2023Form.vue?vue&type=script&lang=js"

import "./MW2023Form.vue?vue&type=style&index=0&id=3e2f0ff9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2f0ff9"]])

export default __exports__